import React, { Component } from "react";
import ModuleRatings from "../../components/Ratings/ModuleRatings";
import CourseAdminNav from "../../components/Navigation/CourseAdminNav";

export class Ratings extends Component {
  render() {
    var table = this.props.location.state.table;
    return (
      <div>
        <CourseAdminNav history={this.props.history} table={table} />
        <ModuleRatings table={table} />
      </div>
    );
  }
}

export default Ratings;
